import * as tslib_1 from "tslib";
import { AfterContentInit, ChangeDetectorRef, OnInit, } from '@angular/core';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { StepBiocatchEnum, } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CardTypeModel, DetailAccountModel, } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from '../../../shared/services/external/crypto-vault/crypto-vault.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../../../shared/services/product-loader/product-loader.service';
import { SignOnService } from '../../../shared/services/sign-on/sign-on.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustCA, callbackAdjustContratarTC, } from 'src/app/shared/constants/adjust-callback';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';
import { PlatformCommunicatorAuthService } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { StringFormatPipe } from 'src/app/shared/pipe/string.format.pipe';
import { PlatformEndpointService } from 'src/app/shared/services/communicator/endpoint/endpoint.service';
import { DaliService } from '@dali/tagger-ng8';
import { EVENT as EVENT_FA_TC, PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
export var AccountCreationStatus;
(function (AccountCreationStatus) {
    AccountCreationStatus["NOT_REQUESTED"] = "notRequested";
    AccountCreationStatus["REQUESTED"] = "requested";
    AccountCreationStatus["REQUEST_FAILED"] = "requestFailed";
    AccountCreationStatus["PEDNING"] = "pending";
    AccountCreationStatus["TIME_OUT_STATUS"] = "timeOutStatus";
    AccountCreationStatus["CREATED"] = "created";
})(AccountCreationStatus || (AccountCreationStatus = {}));
var DetailAccountCreationComponent = /** @class */ (function () {
    function DetailAccountCreationComponent(copyService, headerService, signOnService, authService, bioCatchService, navigationService, abreCuentasService, parametersService, productLoaderService, channelCommunicatorService, bitacoraService, cryptoVaultService, cdr, captureService, requestService, helperService, numberHelper, identificationService, parameterService, validationHelperService, adjustEvent, firmlyApprovedServices, loader, stringFormat, endpointService, taggingServices, daliService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.signOnService = signOnService;
        this.authService = authService;
        this.bioCatchService = bioCatchService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.productLoaderService = productLoaderService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.bitacoraService = bitacoraService;
        this.cryptoVaultService = cryptoVaultService;
        this.cdr = cdr;
        this.captureService = captureService;
        this.requestService = requestService;
        this.helperService = helperService;
        this.numberHelper = numberHelper;
        this.identificationService = identificationService;
        this.parameterService = parameterService;
        this.validationHelperService = validationHelperService;
        this.adjustEvent = adjustEvent;
        this.firmlyApprovedServices = firmlyApprovedServices;
        this.loader = loader;
        this.stringFormat = stringFormat;
        this.endpointService = endpointService;
        this.taggingServices = taggingServices;
        this.daliService = daliService;
        this.showModal = false;
        this.showModalTerm = false;
        this.isBtnDisabled = true;
        this.transactionkit = [];
        this.transactionkitMono = [];
        this.transaction = [];
        this.showSecondaryButton = true;
        this.terms = { text: '', title: '', terms_id: '' };
        this.buttonLabelsModal = {};
        this.buttonLabelsModalTerms = {};
        this.copiesProperty = {};
        this.showFotter = false;
        this.grayZone = false;
        this.check = false;
        this.showMor = true;
        this.noShare = false;
        this.arrowIconDown = 'seta_baixo';
        this.arrowIconUp = 'seta_cima';
        this.productSele = [];
        this.dataProducts = [];
        this.select_products = [];
        this.granted_product_multi = [];
        this.isLoan = false;
        this.lifeMiles = false;
        this.headerService.show(true, true, true);
        this.buttonLabelsModal = {
            primary: copyService.copies.detail_account_creation_modal_button,
        };
        this.buttonLabelsModalTerms = {
            primary: copyService.copies.detail_account_creation_modal_button_terms,
        };
    }
    DetailAccountCreationComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.abreCuentasService.getproductSelected().product_type !== 'livingPlace') {
            this.restrictiveList();
        }
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendDetailCreationPageLoad();
        }
        console.log('---------------------- Detail-account-creation ------------------');
        /**
         * firmlyApproved es un Boolean que indica:
         * True - Viene por flujo de Aprobados en Firme
         * False - viene por flujo Onboarding normal
         */
        var incomes = this.abreCuentasService.getFinancialInfo();
        this.isRevolingCreateSavings = false;
        this.isCreateSavingsLoan = false;
        this.showCharacteristics = incomes.incomes <= 7999000 ? false : true;
        this.firmlyApproved =
            !this.firmlyApprovedServices.isEmpty() &&
                this.firmlyApprovedServices.getOfferType_Channel() === 'En_firme';
        this.productsSelectedMulti = this.abreCuentasService.getProductsSelects();
        this.documentation_to_send = this.copyService.copies.documentation_to_send;
        this.selectedOccupation =
            this.abreCuentasService.getOccupationSelected().name;
        this.requestLoan =
            this.abreCuentasService.getRequestLoanSelected().elementId;
        this.iscardDuality = this.navigationService.cardDuality;
        var postLogin = this.abreCuentasService.getPostlogin();
        var products = postLogin
            ? this.firmlyApproved
                ? this.parameterService.getSetting(OpEnum.APROBADOS_FIRME_CE)
                : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
            : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
        this.multi = products;
        this.viewOptionMultiProduct =
            this.abreCuentasService.viewOptionMultiProduct;
        this.haveloan = this.abreCuentasService.haveLoan;
        this.granted_product_multi = !this.firmlyApproved
            ? this.abreCuentasService.getPcoModel().granted_product_multi
            : this.firmlyApprovedServices.getDetailProductsMulti();
        this.copiesProperty = {
            termsLabel: 'detail_account_creation_link_label',
            nextButtonLabel: 'detail_account_creation_button',
            ContButtonLabel: 'detail_account_creation_button_Cont',
            mainLabel: 'detail_account_creation_title_saving',
            mainLabel2: 'detail_bonding',
            transactionsLabel: 'detail_account_creation_label_transaction',
        };
        var product = this.abreCuentasService.getproductSelected()
            .product_code;
        this.grayZone = this.abreCuentasService.isGrayZone();
        var isEvidente = this.bioCatchService.isEvidenteCase();
        this.bioCatchService.changeContext(StepBiocatchEnum.vinculacion, product, !postLogin, isEvidente);
        this.termsAndConditions =
            this.abreCuentasService.getPayDayProductSelected();
        this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
        if (this.viewOptionMultiProduct) {
            this.checkboxTerms = {
                id: '1',
                label: this.copyService.copies.detail_account_creation_term,
                checked: false,
                value: '1',
            };
        }
        else if (!this.viewOptionMultiProduct) {
            this.checkboxTerms = {
                id: '1',
                label: this.copyService.copies.detail_account_creation_terms,
                checked: false,
                value: '1',
            };
        }
        var selectedProduct = this.abreCuentasService.getPayDayProductSelected().selectedProduct;
        this.selectedPayDayProduct = selectedProduct;
        this.transaction = JSON.parse(JSON.stringify(this.parametersService.getSetting(OpEnum.TRANSACTION_KIT)));
        this.revolvingBenefits = this.parametersService.getSetting(OpEnum.REVOLVING_BENEFITS);
        if (!this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)) {
            return;
        }
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        this.selectedProduct = this.abreCuentasService.getproductSelected();
        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
            var event_1 = {
                eventToken: '3duuk6',
                callbackParams: callbackAdjustCA,
            };
            this.adjustEvent.adjustTrackEvent(event_1);
        }
        setTimeout(function () {
            _this.showFotter = true;
        }, 100);
        /* this.showBackButton(); */
        this.accountDetail();
        this.filterSettingsMulti();
    };
    DetailAccountCreationComponent.prototype.ngAfterContentInit = function () {
        this.cdr.detectChanges();
    };
    /**
     * Summary capture account details
     */
    DetailAccountCreationComponent.prototype.accountDetail = function () {
        var _this = this;
        if (this.iscardDuality) {
            this.multi = this.multi.filter(function (product) { return product.product_type === 'multi'; });
            this.selectedProduct = this.multi[0];
            this.viewOptionMultiProduct = true;
        }
        this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
        this.client = this.abreCuentasService.getProspectResponse().client;
        if (this.infoInferredIncomes.account_type === '232' &&
            this.abreCuentasService.getSegmentID() === '335') {
            this.copiesProperty = {
                termsLabel: 'detail_account_creation_link_label',
                nextButtonLabel: 'detail_account_creation_button',
                mainLabel: 'detail_account_creation_title_saving_basic',
                mainLabel2: 'detail_bonding',
                transactionsLabel: 'detail_account_creation_label_transaction',
            };
        }
        if (this.client &&
            (this.abreCuentasService.getSegmentID() === '335' ||
                this.abreCuentasService.getSegmentID() === '315')) {
            this.infoInferredIncomes.segment_id =
                this.abreCuentasService.getCustomerData().basic.sub_segment_id;
        }
        // Cuenta de ahorros tradicional
        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
            var accountsTermsText = this.parametersService
                .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
                .filter(function (accountTerm) { return _this.getValueObject(accountTerm, 'id') === 1; });
            this.terms = {
                text: accountsTermsText[0].description,
                title: accountsTermsText[0].code,
                terms_id: this.getValueObject(accountsTermsText[0], 'id'),
            };
        }
        // Cuenta de nómina
        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
            var accountsTermsText = this.parametersService
                .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
                .filter(function (accountTerm) { return _this.getValueObject(accountTerm, 'id') === 1; });
            this.terms = {
                text: accountsTermsText[0].description,
                title: accountsTermsText[0].code,
                terms_id: this.getValueObject(accountsTermsText[0], 'id'),
            };
            if (this.viewOptionMultiProduct) {
                this.checkboxTerms = {
                    id: this.terms.terms_id,
                    label: this.copyService.copies.detail_account_creation_term,
                    checked: false,
                    value: this.terms.terms_id,
                };
            }
            else if (!this.viewOptionMultiProduct) {
                this.checkboxTerms = {
                    id: this.terms.terms_id,
                    label: this.copyService.copies.detail_account_creation_terms,
                    checked: false,
                    value: this.terms.terms_id,
                };
            }
            this.copiesProperty = {
                termsLabel: 'detail_account_creation_link_label',
                nextButtonLabel: 'detail_account_creation_button_tc',
                mainLabel: 'detail_account_creation_title_payroll',
                mainLabel2: 'detail_bonding',
                transactionsLabel: 'detail_account_creation_label_benefit',
            };
            this.transactionkit = this.transaction.filter(function (transaction) {
                return transaction.account_type === _this.infoInferredIncomes.account_type &&
                    transaction.segmentation_id ===
                        _this.abreCuentasService.getSegmentID();
            });
            this.transactionkit = this.transactionkit[0];
            this.agreementSelected = this.abreCuentasService.getAgreementSelected();
            if (this.agreementSelected.transaction_type === 'false') {
                this.benefitsList = this.abreCuentasService.getBenefitsList();
                this.navigationService.getCurrentStep().tag_name = this.client
                    ? 'pv131'
                    : 'pv217';
            }
            else {
                this.copiesProperty = {
                    termsLabel: 'detail_account_creation_link_label',
                    nextButtonLabel: 'detail_account_creation_button_tc',
                    mainLabel: 'detail_account_creation_title_payroll',
                    mainLabel2: 'detail_bonding',
                    transactionsLabel: 'detail_account_creation_label_transaction',
                };
            }
            return;
        }
        // TC
        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
            // this.copiesProperty.mainLabel
            this.copiesProperty = {
                termsLabel: 'detail_account_creation_link_label_tc',
                nextButtonLabel: 'detail_account_creation_button_tc',
                mainLabel: 'detail_account_creation_title_tc_success',
                mainLabel2: 'detail_bonding',
                transactionsLabel: 'detail_account_creation_label_transaction_tc',
            };
            if (!this.grayZone) {
                var event_2 = {
                    eventToken: 'bx7giv',
                    callbackParams: callbackAdjustContratarTC,
                };
                this.adjustEvent.adjustTrackEvent(event_2);
            }
            var creditCardTermsText = this.parametersService
                .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
                .filter(function (accountTerm) { return _this.getValueObject(accountTerm, 'id') === 2; });
            this.terms = {
                text: creditCardTermsText[0].description,
                title: creditCardTermsText[0].code,
                terms_id: this.getValueObject(creditCardTermsText[0], 'id'),
            };
            this.checkboxTerms = {
                id: this.terms.terms_id,
                label: this.copyService.copies.detail_account_creation_terms_tc,
                checked: false,
                value: this.terms.terms_id,
            };
            var card_1 = this.abreCuentasService.getCardTypeModel();
            this.cardType = tslib_1.__assign({}, card_1, { periodo_exoneracion: card_1.periodo_exoneracion
                    ? card_1.periodo_exoneracion.toLowerCase().replace(' ', ' primeros ')
                    : '', couta_manejo: card_1.couta_manejo
                    ? card_1.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                    : '', meta_facturacion_mensual: card_1.meta_facturacion_mensual
                    ? card_1.meta_facturacion_mensual.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                    : '' });
            this.grayZone = this.abreCuentasService.isGrayZone();
            this.segment = this.abreCuentasService.getSegmentID();
            this.transactionkit = this.transaction.filter(function (transaction) {
                return transaction.account_type === '219' &&
                    transaction.segmentation_id === _this.segment;
            });
            this.transactionkit = this.transactionkit[0];
            if (this.grayZone === true &&
                this.abreCuentasService.getPostlogin() === true) {
                this.navigationService.getCurrentStep().tag_name = 'pv453';
            }
            else if (this.grayZone === true &&
                this.abreCuentasService.getPostlogin() === false) {
                this.navigationService.pageLoadTag(false, ['pv418', '', '', '']);
            }
            this.transactionkit.detail[0].value =
                this.cardType.tipo_tarjeta.replace('Ã¡', '\u00E1') +
                    ' ' +
                    this.abreCuentasService.getPayDayProductSelected().selectedProduct
                        .label;
            // this.transactionkit.detail[2].detail = this.cardType.periodo_exoneracion;
            if (this.termsAndConditions &&
                this.termsAndConditions.hasOwnProperty('selectedPayDay') &&
                this.termsAndConditions.selectedPayDay.hasOwnProperty('label')) {
                this.transactionkit.detail[3].value =
                    this.termsAndConditions.selectedPayDay.label;
            }
            if (card_1.brand === 'VISA LIFE MILES' &&
                (card_1.tipo_tarjeta === 'Gold' || card_1.tipo_tarjeta === 'Signature')) {
                this.lifeMiles = true;
                this.transactionkitMono = this.copyService.getCopy('detail_account_life_miles');
            }
            else if (card_1.tipo_tarjeta === 'Gold' ||
                card_1.tipo_tarjeta === 'Platinum' ||
                card_1.tipo_tarjeta === 'Infinite' ||
                card_1.tipo_tarjeta === 'Clasica' ||
                card_1.tipo_tarjeta === 'Black') {
                var product = void 0;
                if (this.firmlyApproved) {
                    product = this.firmlyApprovedServices
                        .getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
                        .find(function (element) {
                        return (String(element.brand).toLowerCase() ===
                            String(card_1.brand).toLowerCase());
                    });
                }
                else {
                    product = this.abreCuentasService.getPcoModel().granted_product;
                }
                this.lifeMiles =
                    product.limit_amount.amount < 4000000 &&
                        card_1.tipo_tarjeta === 'Clasica'
                        ? true
                        : false;
                this.transactionkitMono = this.copyService.getCopy('detail_account_no_life_miles');
            }
            console.warn('Lifemiles: ', this.lifeMiles);
            this.transactionkit.share[0].description =
                this.copyService.getParametrizedCopy('detail_account_use_and_dont_pay_text', [this.cardType.meta_facturacion_mensual, this.cardType.couta_manejo]);
            if (this.grayZone) {
                this.copiesProperty = {
                    termsLabel: 'detail_account_creation_link_label_tc',
                    nextButtonLabel: 'detail_account_creation_button_tc',
                    mainLabel: 'detail_account_creation_title_tc',
                    mainLabel2: 'detail_bonding',
                    transactionsLabel: 'detail_account_creation_label_transaction_tc',
                };
                if (this.transactionkit.detail[0].detail !== 'Número de solicitud') {
                    this.transactionkit.detail[0].value =
                        this.abreCuentasService.getPayDayProductSelected().selectedProduct.label;
                    this.transactionkit.detail[0].detail = this.copyService.getCopy('detail_account_creation_franchise');
                }
                this.copiesProperty['termsLabel'] =
                    'detail_account_creation_link_label_tc';
                var transactionNumber = {
                    detail: 'Número de solicitud',
                    value: this.abreCuentasService.getSolicitationId(),
                };
                var evento = {
                    eventToken: 'k4b9yo',
                    callbackParams: callbackAdjustContratarTC,
                };
                this.adjustEvent.adjustTrackEvent(evento);
                if (this.transactionkit.detail[0].detail !== 'Número de solicitud') {
                    this.transactionkit.detail.unshift(transactionNumber);
                }
                else {
                    this.transactionkit.detail[0] = transactionNumber;
                }
                var detailTK = this.transactionkit.detail.filter(function (transaction) {
                    return transaction.detail !== 'Tarjeta virtual' &&
                        transaction.detail !== '2 primeros meses' &&
                        transaction.detail !== '';
                });
                this.transactionkit.detail = detailTK;
            }
            else {
                if (!this.viewOptionMultiProduct) {
                    var products_firmlyApproved = void 0;
                    if (this.firmlyApproved) {
                        products_firmlyApproved = this.firmlyApprovedServices
                            .getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
                            .find(function (element) {
                            return (String(element.brand).toLowerCase() ===
                                String(card_1.brand).toLowerCase());
                        });
                    }
                    this.amountPco = this.firmlyApproved
                        ? products_firmlyApproved.limit_amount.amount
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                        : this.abreCuentasService
                            .getPcoModel()
                            .granted_product.limit_amount.amount.toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                }
                this.agreementSelected = this.abreCuentasService.getAgreementSelected();
            }
            if (this.transactionkit.id === 3 &&
                this.abreCuentasService.getPostlogin() === true &&
                !this.grayZone === true) {
                this.navigationService.getCurrentStep().tag_name = 'pv452';
            }
            else if (this.transactionkit.id === 3 &&
                !this.abreCuentasService.getPostlogin() === true &&
                !this.grayZone === true) {
                this.navigationService.pageLoadTag(false, ['pv54', '', '', '']);
            }
            return;
        }
        this.setSubTitle();
        this.setBTNNex();
        if (this.selectedProduct.product_type === BUSINESS_CONST.MULTI) {
            var accountsTermsText = this.parametersService
                .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
                .filter(function (accountTerm) { return _this.getValueObject(accountTerm, 'id') === 3; });
            this.terms = {
                text: accountsTermsText[0].description,
                title: accountsTermsText[0].code,
                terms_id: this.getValueObject(accountsTermsText[0], 'id'),
            };
            var productList = this.abreCuentasService.getProductsSelects();
            productList.forEach(function (element) {
                if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                    _this.freeInvestmentDetail();
                }
                if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
                    _this.creditCardDetail();
                }
                if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
                    _this.revolvingDetail();
                }
                if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                    _this.loanDetail();
                }
            });
            if (productList.find(function (find) { return find.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                this.savingAccountDetailRevolving();
            }
            if (productList.find(function (find) { return find.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                this.savingAccountDetail();
            }
            if (this.client && this.abreCuentasService.getcreateProductSelected() && !this.abreCuentasService.haveLoan) {
                var accounts = this.abreCuentasService.getcreateProductSelected();
                this.accountNumber = "" + this.validationHelperService.maskPhone(accounts.account_id);
            }
            return;
        }
        this.transactionkit = this.transaction.filter(function (transaction) {
            return transaction.account_type === _this.infoInferredIncomes.account_type &&
                transaction.segmentation_id === _this.abreCuentasService.getSegmentID();
        });
        this.transactionkit = this.transactionkit[0];
        if (this.getValueObject(this.transactionkit, 'id') === 3) {
            this.navigationService.getCurrentStep().tag_name =
                this.abreCuentasService.getProspectResponse().client ? 'pv95' : 'pv210';
        }
        else if (this.getValueObject(this.transactionkit, 'id') === 2) {
            this.navigationService.pageLoadTag(false, ['', '', 'pv92', '']);
        }
        else if (this.getValueObject(this.transactionkit, 'id') === 1) {
            this.navigationService.pageLoadTag(false, ['', '', 'pv89', '']);
        }
    };
    DetailAccountCreationComponent.prototype.filterSettingsMulti = function () {
        var e_1, _a;
        this.select_products = this.abreCuentasService.getProductsSelects();
        this.productsMulti =
            this.abreCuentasService.getPcoModel().granted_product_multi;
        // this.productsMulti.forEach(item => {
        //   this.productSele.push(item.product_type);
        // });
        var products = this.firmlyApproved
            ? this.firmlyApprovedServices.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
            : this.productsMulti.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC; });
        var quotaFranchise = this.parameterService.getSetting(OpEnum.COST_QUOTA_TC_FRANCHISE);
        var _loop_1 = function (row) {
            if (row.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
                if (this_1.select_products.filter(function (fil) { return fil.product_type == row.product_type; })[0].name != undefined) {
                    row.es = this_1.select_products.filter(function (fil) { return fil.product_type == row.product_type; })[0].name;
                }
                if (row.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC &&
                    this_1.iscardDuality) {
                    row.cardTypes.forEach(function (target) {
                        products.forEach(function (product) {
                            if (target.brand === product.brand) {
                                var rate = quotaFranchise.find(function (filter) {
                                    return filter.montoMin <= product.limit_amount.amount &&
                                        filter.montoMax >= product.limit_amount.amount;
                                });
                                target.meta_facturacion_mensual = rate.quota
                                    .toString()
                                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                                target.granted_product = product;
                                target.granted_product.limit_amount.amount =
                                    target.granted_product.limit_amount.amount
                                        .toString()
                                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                            }
                        });
                    });
                }
                else {
                    row.granted_product = this_1.productsMulti.find(function (fil) { return fil.product_type == row.product_type; });
                    // row.granted_product = products;
                    if (this_1.abreCuentasService.isGrayZone() &&
                        row.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                        var creditParams = this_1.abreCuentasService.getAbreCuentasModel().creditParms;
                        row.granted_product.limit_amount.amount =
                            creditParams.maxAmountValue;
                    }
                    row.granted_product.limit_amount.amount =
                        row.granted_product.limit_amount.amount
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                }
            }
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(this.dataProducts), _c = _b.next(); !_c.done; _c = _b.next()) {
                var row = _c.value;
                _loop_1(row);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Summary Show Modal
     */
    DetailAccountCreationComponent.prototype.toggleModal = function () {
        this.navigationService.pageLoadTag(false, ['', 'pv133', 'pv90', '']);
        if (this.showSecondaryButton) {
            this.showModal = !this.showModal;
        }
        this.showSecondaryButton = true;
    };
    /**
     * Summary Show Modal Terms
     */
    DetailAccountCreationComponent.prototype.modalActionTerms = function (event) {
        if (event.type === 'primary') {
            this.showModalTerm = !this.showModalTerm;
        }
    };
    DetailAccountCreationComponent.prototype.toggleModalTerms = function () {
        this.showModalTerm = !this.showModalTerm;
    };
    /**
     * Acción del modal
     *
     * *Modal action*
     *
     * @param event
     * @type {function}
     */
    DetailAccountCreationComponent.prototype.modalAction = function (event) {
        if (event.type === 'primary') {
            this.downloadPdf();
        }
    };
    /**
     * Method to download pdf
     */
    DetailAccountCreationComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService
            .getImpl()
            .openPdf(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
            .pdfUrl);
    };
    /**
     * Summary Event to change checkbox and set Prop
     * @param event
     */
    DetailAccountCreationComponent.prototype.checkboxChange = function (event) {
        this.checkboxTerms.checked = event.checked;
        this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
        this.enableNextButton();
    };
    /**
     * Summary Enable the Button
     */
    DetailAccountCreationComponent.prototype.enableNextButton = function () {
        this.isBtnDisabled =
            !this.abreCuentasService.getFiProperty('checkboxTerms').checked;
    };
    /**
     * summary shipment request open account
     */
    DetailAccountCreationComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var gray_zone, bitacoraEvent, bitacoraEventPre, nextStepSuccessful, enrol;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.taggingServices.isFirmlyAprovedMono()) {
                            this.sendContinueButtonEvent();
                        }
                        gray_zone = '';
                        if (this.abreCuentasService.isGrayZone()) {
                            gray_zone = '_zg';
                        }
                        bitacoraEvent = this.selectedProduct.product_type ===
                            BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
                            this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL
                            ? 'product_terms'
                            : 'product_accepted';
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        bitacoraEventPre = this.firmlyApproved ? 'offer_approvedf_multi' : 'Product_accepted';
                        this.dataProducts.forEach(function (product) {
                            if (_this.firmlyApproved) {
                                var productCode = {};
                                productCode[BUSINESS_CONST.PRODUCT_TYPE_FREE] = BUSINESS_CONST.PRODUCT_CODE_ORD;
                                productCode[BUSINESS_CONST.PRODUCT_TYPE_TC] = BUSINESS_CONST.PRODUCT_CODE_TCR;
                                productCode[BUSINESS_CONST.PRODUCT_TYPE_REVOLVING] = BUSINESS_CONST.PRODUCT_CODE_CRP;
                                productCode['default'] = '';
                                bitacoraEventPre = bitacoraEventPre + "_" + (productCode[product.product_type] ? productCode[product.product_type] : productCode['default']);
                            }
                            else {
                                if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                                    _this.bitacoraService.saveDataInBitacora("" + bitacoraEventPre + gray_zone + "_ord");
                                }
                                if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                                    _this.bitacoraService.saveDataInBitacora("" + bitacoraEventPre + gray_zone + "_lbza");
                                }
                                if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
                                    _this.bitacoraService.saveDataInBitacora("" + bitacoraEventPre + gray_zone + "_tc");
                                }
                                if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
                                    _this.bitacoraService.saveDataInBitacora("" + bitacoraEventPre + gray_zone + "_rot");
                                }
                            }
                        });
                        if (this.firmlyApproved) {
                            this.bitacoraService.saveDataInBitacora(bitacoraEventPre);
                        }
                        return [4 /*yield*/, this.callCreatePerform()];
                    case 1:
                        _a.sent();
                        nextStepSuccessful = !this.grayZone ? '200' : '201';
                        if (this.acctStatus ===
                            AccountCreationStatus.REQUEST_FAILED ||
                            this.acctStatus ===
                                AccountCreationStatus.NOT_REQUESTED) {
                            return [2 /*return*/];
                        }
                        // Waits for a while.
                        this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.BONDING_ASYNC)['sleep'])];
                    case 2:
                        _a.sent();
                        enrol = this.stringFormat.transform(this.endpointService.URLS.ENROLLMENT, [this.authService.getSessionId()]);
                        this.captureService
                            .getChannelComunicator(true)
                            .then(function (res2) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var goToEnrollment, event_3;
                            return tslib_1.__generator(this, function (_a) {
                                goToEnrollment = this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['active'][this.selectedProduct.product_type]
                                    ? this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['active'][this.selectedProduct.product_type]
                                    : (this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['pasive'][this.selectedProduct.product_type]
                                        ? this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['pasive'][this.selectedProduct.product_type]
                                        : false);
                                if ((this.channelCommunicatorService.getChannelId() === '141')
                                    && !this.abreCuentasService.getPostlogin()
                                    && goToEnrollment) {
                                    console.warn('Go To ENROLLMENT: ', goToEnrollment, ' - url: ', enrol);
                                    this.channelCommunicatorService.getImpl().openPage(enrol, 5, false);
                                    this.loader.hide('Alta_Productos_zn');
                                }
                                else if ((CHANNEL.PORTALO.CODE ===
                                    this.channelCommunicatorService.getChannelId()) &&
                                    this.abreCuentasService.getflagGreyZone()) {
                                    this.loader.hide('Alta_Productos_zn');
                                    this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                    this.navigationService.navigateToGeneralInformation('137');
                                    return [2 /*return*/];
                                }
                                else if (nextStepSuccessful === '200') {
                                    this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                    this.navigateValidateSaving(nextStepSuccessful);
                                    return [2 /*return*/];
                                }
                                else {
                                    res2 === '107' ||
                                        res2 === '121' ||
                                        res2 === '130' ||
                                        res2 === '129' ||
                                        res2 === '124' ||
                                        res2 === '125' ||
                                        res2 === '127'
                                        ? this.navigationService.navigateToGeneralInformation(res2)
                                        : this.navigationService.nextStep(res2);
                                }
                                if (res2 === '124' &&
                                    this.abreCuentasService.getPostlogin() === true &&
                                    !this.grayZone === true) {
                                    this.navigationService.pageLoadTag('SolicitudEnProcesoTimeOut', [
                                        'pv456',
                                        '',
                                        '',
                                        '',
                                    ]);
                                }
                                if (res2 === '208') {
                                    this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
                                }
                                else if (res2 === '20-04') {
                                    res2 = '208';
                                    this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
                                }
                                if (this.selectedProduct.product_type ===
                                    BUSINESS_CONST.PRODUCT_TYPE_TC &&
                                    res2 === '121') {
                                    event_3 = {
                                        eventToken: 'huswfn',
                                        callbackParams: callbackAdjustContratarTC,
                                    };
                                    this.adjustEvent.adjustTrackEvent(event_3);
                                }
                                this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                this.productLoaderService.hide();
                                this.loader.hide('Alta_Productos_zn');
                                return [2 /*return*/];
                            });
                        }); })
                            .catch(function () {
                            _this.loader.hide('Alta_Productos_zn');
                            _this.navigationService.navigateToGeneralInformation('107');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DetailAccountCreationComponent.prototype.navigateValidateSaving = function (nextStepSuccessful) {
        this.loader.hide('Alta_Productos_zn');
        if (nextStepSuccessful === '200') {
            if (!this.firmlyApprovedServices.isEmpty()) {
                var product_list = [];
                product_list.push(this.abreCuentasService.getproductSelected());
                if (product_list[0] && product_list[0].product_code === 'MULTI') {
                    var productsType_1 = {
                        freeInvestment: 'ORD',
                        creditCard: 'TCR',
                        revolvingCredit: 'CRP',
                    };
                    var products = this.firmlyApprovedServices.getDetailProductsMulti();
                    var offerProducts_1 = [];
                    products.forEach(function (product) {
                        if (!offerProducts_1.some(function (offerType) { return offerType === productsType_1[product.product_type]; })) {
                            offerProducts_1.push(productsType_1[product.product_type]);
                        }
                    });
                    product_list = [{
                            product_code: String(offerProducts_1),
                        }];
                }
                this.firmlyApprovedServices.turnOffOffer(OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE, product_list);
            }
            if (this.selectedProduct.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC) {
                this.loader.hide('Alta_Productos_zn');
                this.navigationService.navigateToGeneralInformation('138');
                return;
            }
            else if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                if (this.client) {
                    var products_savings = void 0;
                    if (this.abreCuentasService.getClientProduct()) {
                        products_savings = this.abreCuentasService.getListClientProduct().filter(function (products) {
                            return products.product_type === 'AHO';
                        });
                    }
                    else {
                        products_savings = [];
                    }
                    if (products_savings.length >= 1) {
                        this.navigationService.navigateToGeneralInformation('138');
                        return;
                    }
                    else {
                        this.navigationService.navigateToGeneralInformation('136');
                        return;
                    }
                }
                else {
                    this.navigationService.navigateToGeneralInformation('136');
                    return;
                }
            }
            return;
        }
    };
    DetailAccountCreationComponent.prototype.callCreatePerform = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
                        this.signOnService.termsAndConditions();
                        body = {
                            data: [
                                {
                                    solicitation_completed: true,
                                    solicitation_type: 'tskAvanzarProcesoDigital',
                                },
                            ],
                        };
                        return [4 /*yield*/, this.signOnService
                                .createCasePerformSolicitation(body, this.abreCuentasService.getSolicitationId())
                                .then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    try {
                                        this.acctProcessId = res.data.solicitation_id;
                                        this.acctStatus = AccountCreationStatus.REQUESTED;
                                    }
                                    catch (error) {
                                        this.acctStatus = AccountCreationStatus.REQUEST_FAILED;
                                        this.loader.hide('Alta_Productos_zn');
                                        this.navigationService.navigateToGeneralInformation('500');
                                        return [2 /*return*/];
                                    }
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function () {
                                _this.acctStatus = AccountCreationStatus.REQUEST_FAILED;
                                _this.loader.hide('Alta_Productos_zn');
                                _this.navigationService.navigateToGeneralInformation('127');
                                return;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DetailAccountCreationComponent.prototype.checkBioCatch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var gray_zone, product_name, bitacoraEvent, productType;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.show('Alta_Productos_zn');
                        gray_zone = '';
                        product_name = this.abreCuentasService.getproductSelected().product_code;
                        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC &&
                            this.abreCuentasService.isGrayZone()) {
                            gray_zone = 'zg_';
                        }
                        bitacoraEvent = '';
                        if (this.firmlyApproved && product_name !== 'MULTI') {
                            productType = {
                                ORD: 'cp',
                                TCR: 'tc',
                                CRP: 'cr',
                                default: '',
                            };
                            this.bitacoraService.saveDataInBitacora("offer_approvedf_" + product_name);
                            bitacoraEvent = "af_accepted_multi_" + (productType[product_name] ? productType[product_name] : productType.default);
                        }
                        else {
                            bitacoraEvent = "product_accepted_" + gray_zone + product_name;
                        }
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        if (!(product_name === 'TCR')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.checkRelated()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.bioCatchService.update()];
                    case 3:
                        _a.sent();
                        this.bioCatchService
                            .checkScore(false)
                            .then(function (response) {
                            console.log('--------- Response Biocatch Score---------');
                            console.log(response);
                            if (response.data.response) {
                                _this.next();
                                return;
                            }
                            _this.productLoaderService.hide();
                            _this.navigationService.navigateToGeneralInformation('122');
                            if (_this.abreCuentasService.getPostlogin() === true) {
                                _this.navigationService.pageLoadTag('ErrorBiocatch', [
                                    '',
                                    '',
                                    'pv580',
                                    '',
                                ]);
                            }
                            else {
                                _this.navigationService.pageLoadTag('ErrorCrearTuCuenta', [
                                    '',
                                    '',
                                    'pv582',
                                    '',
                                ]);
                            }
                            _this.productLoaderService.hide();
                            _this.navigationService.pageLoadTag('Error carga vinculacion', [
                                '',
                                'pv132',
                                'pv93',
                            ]);
                        }, function () {
                            _this.navigationService.navigateToGeneralInformation('500');
                            _this.productLoaderService.hide();
                        })
                            .catch(function () {
                            _this.productLoaderService.hide();
                            _this.navigationService.navigateToGeneralInformation('500');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DetailAccountCreationComponent.prototype.checkRelated = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document, resInfo, bitacoraEvent, pcoStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.continueRelated = true;
                        document = this.abreCuentasService.getDocumentInfo().document_number;
                        return [4 /*yield*/, this.identificationService.validateIfIsRelated(document)];
                    case 1:
                        resInfo = _a.sent();
                        if (!resInfo.related) {
                            return [2 /*return*/];
                        }
                        bitacoraEvent = "employee_members";
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
                        // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
                        if (pcoStatus !== 'PCO01') {
                            return [2 /*return*/];
                        }
                        this.navigationService.nextStep('202');
                        this.continueRelated = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Opens link to itau page
     *
     *
     * @memberof DetailAccountCreationComponent
     */
    DetailAccountCreationComponent.prototype.openLink = function () {
        this.channelCommunicatorService
            .getImpl()
            .openExternalBrowser(this.copyService.copies.detail_account_creation_link, 5, true);
    };
    DetailAccountCreationComponent.prototype.showMore = function (product_type) {
        if (this.active == product_type) {
            this.active = '';
        }
        else {
            this.active = product_type;
        }
    };
    DetailAccountCreationComponent.prototype.getValueObject = function (object, property) {
        if (object && object.hasOwnProperty(property)) {
            return object[property];
        }
        else {
            // tslint:disable-next-line:no-return-undefined
            return undefined;
        }
    };
    DetailAccountCreationComponent.prototype.freeInvestmentDetail = function () {
        var transaction = this.transaction.filter(function (transactionFilter) {
            return transactionFilter.account_type === '211' &&
                transactionFilter.segmentation_id === '315';
        });
        if (this.granted_product_multi.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
            var rates = this.firmlyApproved
                ? this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue
                : this.requestService.getRates();
            var rate = this.firmlyApproved
                ? rates.rate_EA + "% EA  (" + rates.rate_MV + "% MV)"
                : rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            this.dataProducts.push({
                product_type: BUSINESS_CONST.PRODUCT_TYPE_FREE,
                rate: rate,
                transactionkit: this.copyService.getCopy('detail_account_creation_free_investment'),
                maxPeriodValue: this.abreCuentasService.getAbreCuentasModel().creditParms
                    .maxPeriodValue,
                es: BUSINESS_CONST.FREE_INVESTMENT,
            });
        }
    };
    DetailAccountCreationComponent.prototype.monthly = function (months) {
        return months + " " + this.copyService.copies.account_info_creation.monthly;
    };
    DetailAccountCreationComponent.prototype.isGranted = function (product_type) {
        var productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
        var granteds = productsGranted.filter(function (i) { return i.product_type === product_type; });
        return granteds.length > 0;
    };
    DetailAccountCreationComponent.prototype.loanDetail = function () {
        if (this.granted_product_multi.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
            this.disbursment = this.abreCuentasService.getDisbursementInfo();
            var refund = void 0;
            if (this.disbursment && this.disbursment.length > 0) {
                refund = this.disbursment[0].refund;
            }
            if (refund && refund[0] && refund[0].refund_method !== 'CH') {
                this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
            }
            this.isCreateSavingsLoan = this.accountNumber === '';
            this.check = this.abreCuentasService.getOutlaySelection() === 'cheque';
            var creditParamsLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
            this.dataProducts.push({
                product_type: BUSINESS_CONST.PRODUCT_TYPE_LOAN,
                amount: this.numberHelper.pcoFormat(creditParamsLib.maxAmountValue),
                rate: this.abreCuentasService.getRatesLoan(),
                transactionkit: '',
                maxPeriodValue: creditParamsLib.maxPeriodValue,
            });
        }
    };
    DetailAccountCreationComponent.prototype.setAccounterNumber = function (refund) {
        if (refund && refund[0] && refund[0].refund_method !== 'CH') {
            this.accountNumber = refund[0].account
                ? this.validationHelperService.maskPhone(refund[0].account.account_id)
                : '';
        }
    };
    DetailAccountCreationComponent.prototype.creditCardDetail = function () {
        var _this = this;
        var card = this.iscardDuality
            ? this.abreCuentasService.getCardTypesModel()
            : this.abreCuentasService.getCardTypeModel();
        var transaction = this.transaction.filter(function (transactionFilter) {
            return transactionFilter.account_type === '219' &&
                transactionFilter.segmentation_id ===
                    _this.abreCuentasService.getSegmentID();
        });
        if (!this.iscardDuality) {
            this.cardType = tslib_1.__assign({}, card, { periodo_exoneracion: card.periodo_exoneracion
                    ? card.periodo_exoneracion.toLowerCase().replace(' ', ' primeros ')
                    : '', couta_manejo: card.couta_manejo
                    ? card.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                    : '', meta_facturacion_mensual: card.meta_facturacion_mensual
                    ? card.meta_facturacion_mensual.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                    : '' });
            transaction[0].detail[0].value =
                this.cardType.tipo_tarjeta.replace('Ã¡', '\u00E1') +
                    ' ' +
                    this.abreCuentasService.getPayDayProductSelected().selectedProduct
                        .label;
            transaction[0].detail[3].value =
                this.abreCuentasService.getPayDayProductSelected().selectedPayDay.label;
            if (this.grayZone) {
                transaction[0].detail[0].detail = 'Franquicia';
                transaction[0].detail = transaction[0].detail.filter(function (filter) {
                    return filter.tag_name === 'typeCard' || filter.tag_name === 'payDay';
                });
            }
            if (this.granted_product_multi.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                this.dataProducts.push({
                    product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
                    cardType: this.cardType,
                    transactionkit: transaction[0],
                    es: BUSINESS_CONST.CREDIT_CARD,
                });
            }
        }
        else {
            var virtualCard_1 = this.abreCuentasService.getVirtualCardFranchise().selectedFranchise;
            var cardvector = Object.values(card);
            cardvector.forEach(function (target) {
                target.periodo_exoneracion =
                    target && target.periodo_exoneracion
                        ? target.periodo_exoneracion
                            .toLowerCase()
                            .replace(' ', ' primeros ')
                        : '';
                target.couta_manejo = target.couta_manejo
                    ? target.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                    : '';
                target.detailDual = transaction[0].detailDual.slice();
                target.virtualCard = target.brand === virtualCard_1.label;
                target.payDay =
                    _this.abreCuentasService.getPayDayProductSelected().selectedPayDay.label;
            });
            cardvector.map(function (outVirtual) {
                if (!outVirtual.virtualCard) {
                    outVirtual.detailDual.splice(1, 1);
                }
            });
            this.dataProducts.push({
                product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
                cardTypes: cardvector,
                transactionkit: transaction[0],
                iscardDuality: this.iscardDuality,
                es: BUSINESS_CONST.CREDIT_CARD,
            });
        }
    };
    DetailAccountCreationComponent.prototype.revolvingDetail = function () {
        var _this = this;
        if (this.granted_product_multi.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
            if (this.abreCuentasService.getAssociateRevolving()) {
                this.accountNumberRevolving = this.validationHelperService.maskPhone(this.abreCuentasService.getAssociateRevolving().account_id);
            }
            var transaction = this.transaction.filter(function (transactionFilter) {
                return transactionFilter.account_type ===
                    _this.infoInferredIncomes.account_type &&
                    transactionFilter.segmentation_id ===
                        _this.abreCuentasService.getSegmentID();
            });
            this.dataProducts.push({
                product_type: BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
                es: this.copyService.copies.gray_zone_type_revolving.productName,
                transactionkit: [],
            });
        }
    };
    DetailAccountCreationComponent.prototype.savingAccountDetail = function () {
        if (!this.abreCuentasService.getcreateProductSelected() && !this.isRevolingCreateSavings) {
            this.createAccountSaving();
        }
    };
    DetailAccountCreationComponent.prototype.savingAccountDetailRevolving = function () {
        if (!this.abreCuentasService.getAssociateRevolving() && !this.isCreateSavingsLoan) {
            this.isRevolingCreateSavings = true;
            this.createAccountSaving();
        }
    };
    DetailAccountCreationComponent.prototype.createAccountSaving = function () {
        var _this = this;
        var transaction = this.transaction.filter(function (transactionFilter) {
            return transactionFilter.account_type ===
                _this.infoInferredIncomes.account_type &&
                transactionFilter.segmentation_id ===
                    _this.abreCuentasService.getSegmentID();
        });
        this.dataProducts.push({
            product_type: BUSINESS_CONST.PRODUCT_TYPE_SAVINGS,
            transactionkit: transaction[0],
            es: 'Cuenta de ahorros',
        });
    };
    DetailAccountCreationComponent.prototype.goToLink = function () {
        this.channelCommunicatorService
            .getImpl()
            .openExternalBrowser('https://www.itau.co/tasasytarifas', 5, true);
    };
    DetailAccountCreationComponent.prototype.getCopiesByCase = function () {
        var _this = this;
        this.productsSelectedMulti.forEach(function (products) {
            if (products.product_type === 'loan') {
                _this.isLoan = true;
                _this.isBtnDisabled = false;
                if (_this.selectedOccupation === 'Empleado' &&
                    _this.requestLoan === '01') {
                    _this.copiesDocToSend = [
                        {
                            desc: _this.documentation_to_send.documentsLibEmployee
                                .proofPayment,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibEmployee
                                .workingLetter,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibEmployee
                                .salaryCertificate,
                        },
                    ];
                }
                else if (_this.selectedOccupation === 'Empleado' &&
                    _this.requestLoan === '02') {
                    _this.copiesDocToSend = [
                        {
                            desc: _this.documentation_to_send.documentsLibEmployeeWithCart
                                .proofPayment,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibEmployeeWithCart
                                .workingLetter,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibEmployeeWithCart
                                .debtCertificateBank,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibEmployeeWithCart
                                .salaryCertificate,
                        },
                    ];
                }
                else if (_this.selectedOccupation === 'Pensionado' &&
                    _this.requestLoan === '01') {
                    _this.copiesDocToSend = [
                        {
                            desc: _this.documentation_to_send.documentsLibPensioner
                                .proofPayment,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensioner
                                .debtStatement,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensioner
                                .salaryCertificate,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensioner
                                .bankStatements,
                        },
                    ];
                }
                else if (_this.selectedOccupation === 'Pensionado' &&
                    _this.requestLoan === '02') {
                    _this.copiesDocToSend = [
                        {
                            desc: _this.documentation_to_send.documentsLibPensionerWithCart
                                .proofPayment,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensionerWithCart
                                .debtCertificateBank,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensionerWithCart
                                .debtStatement,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensionerWithCart
                                .salaryCertificate,
                        },
                        {
                            desc: _this.documentation_to_send.documentsLibPensionerWithCart
                                .bankStatements,
                        },
                    ];
                }
            }
        });
    };
    DetailAccountCreationComponent.prototype.setSubTitle = function () {
        this.subTitle = this.isLoan
            ? this.documentation_to_send.textDescription
            : this.copyService.getParametrizedCopy(this.copiesProperty['mainLabel'], [
                this.documentInfo.firstname,
            ]);
    };
    DetailAccountCreationComponent.prototype.setBTNNex = function () {
        this.labelBTN = this.isLoan
            ? this.documentation_to_send.next
            : this.documentation_to_send.request;
    };
    DetailAccountCreationComponent.prototype.restrictiveList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var restrictive_params, data_user, fullName, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restrictive_params = this.parametersService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
                        data_user = this.abreCuentasService.getDocumentInfo();
                        fullName = data_user.firstname + " " + data_user.middlename + " " + data_user.primary_lastname + " " + data_user.second_lastname;
                        body = {
                            data: {
                                client_name: fullName,
                                document: {
                                    number: data_user.document_number,
                                },
                                user_name: restrictive_params.user_name,
                                employee_id: restrictive_params.employee_id,
                                application: restrictive_params.application,
                                priority: restrictive_params.priority,
                                reference_type: restrictive_params.reference_type,
                                transaction_type: restrictive_params.transaction_type,
                            },
                        };
                        return [4 /*yield*/, this.requestService.getRestrictiveList(body).then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var data;
                                return tslib_1.__generator(this, function (_a) {
                                    data = {
                                        list_query_status: {
                                            status_code: res.data.status_code,
                                        },
                                        client: this.abreCuentasService.getProspectResponse().client,
                                    };
                                    this.abreCuentasService.setProspectResponse(data);
                                    if (res.data.status_code === '5') {
                                        this.navigationService.navigateToGeneralInformation('107');
                                        return [2 /*return*/];
                                    }
                                    return [2 /*return*/];
                                });
                            }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    DetailAccountCreationComponent.prototype.sendDetailCreationPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv13pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv13pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv13pageFamily.path,
                value: PAGEVIEW_FA.pv13pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv13subFamily.path,
                value: PAGEVIEW_FA.pv13subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv13pageAction.path,
                value: PAGEVIEW_FA.pv13pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv13pageid.path,
                value: DetailAccountCreationComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv13transactionName.path,
                value: "" + PAGEVIEW_FA.pv13transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv13transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv13transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    /*  sendBackButtonEvent(): void {
       if (this.taggingServices.isFirmlyAprovedMono()) {
         return;
       }
       const data = [
         {
           path: EVENT_FA_TC.pv13E1setData.pv13E1transactionTransactionStep.path,
           value: EVENT_FA_TC.pv13E1setData.pv13E1transactionTransactionStep.value,
         },
         {
           path: EVENT_FA_TC.pv13E1setData.pv13E1transactionName.path,
           value: EVENT_FA_TC.pv13E1setData.pv13E1transactionName.value, // cambiar valor segun sea LD o TC
         },
       ];
       const event = {
         category: {
           module: EVENT_FA_TC.customCategory.module.body,
           type: EVENT_FA_TC.customCategory.type.button,
           position: EVENT_FA_TC.customCategory.position.center,
         },
         action: EVENT_FA_TC.customAction.click,
         label: EVENT_FA_TC.pv13E1customLabel,
       };
       this.daliService.trackEvent(event, data);
     } */
    DetailAccountCreationComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_TC.pv13E2setData.pv13E2transactionTransactionStep.path,
                value: EVENT_FA_TC.pv13E2setData.pv13E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv13E2setData.pv13E2transactionName.path,
                value: EVENT_FA_TC.pv13E2setData.pv13E2transactionName.value,
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv13E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    return DetailAccountCreationComponent;
}());
export { DetailAccountCreationComponent };
